import { type Timestamp, timestampDate } from '@bufbuild/protobuf/wkt'
import { differenceInCalendarDays } from 'date-fns'

import type { GroupedWeightNodeData } from '@/components/lemmala-design-system/table/types'

export const timestampComparator = (a?: Timestamp, b?: Timestamp): number => {
  if (!a && !b) return 0
  if (!a) return 1
  if (!b) return -1
  return Number(a.seconds) - Number(b.seconds)
}

// Same local calendar day compares equal, so a secondary sort column decides the order within a day.
export const timestampDayComparator = (a?: Timestamp, b?: Timestamp): number => {
  if (!a && !b) return 0
  if (!a) return 1
  if (!b) return -1
  return differenceInCalendarDays(timestampDate(a), timestampDate(b))
}

export const numericComparator = (valueA: number, valueB: number): number => {
  const numA = typeof valueA === 'number' ? valueA : 0
  const numB = typeof valueB === 'number' ? valueB : 0
  return numA - numB
}

export const categoryWeightComparator = (
  _valueA: number,
  _valueB: number,
  nodeA: { data?: GroupedWeightNodeData },
  nodeB: { data?: GroupedWeightNodeData },
): number => {
  // Get effective weight for each row
  // Headers have categoryMetrics.totalWeight, controls have categoryTotalWeight
  const weightA = nodeA?.data?.isGroupHeader
    ? (nodeA?.data?.categoryMetrics?.totalWeight ?? 0)
    : (nodeA?.data?.categoryTotalWeight ?? 0)

  const weightB = nodeB?.data?.isGroupHeader
    ? (nodeB?.data?.categoryMetrics?.totalWeight ?? 0)
    : (nodeB?.data?.categoryTotalWeight ?? 0)

  // Otherwise, sort by weight
  return weightA - weightB
}
